import { makeAutoObservable, runInAction } from "mobx";
const GROUPMODE = true;
const ALLMODE = false;

export default class GameStore {
  _answerAlbumList;
  _userAlbumList;
  _currentAlbum;
  _gameMode;
  _filterAlbumMode;
  _groupId;
  _round;
  _scoreMax;
  _multiplicatorScore;
  _score;
  _lifeMax;
  _life;
  _time;  // non fonctionel
  _endSequenceFunction;
  _readyToStart;

  constructor() {
    this._answerAlbumList = [];
    this._userAlbumList = [];
    this._currentAlbum = [];
    this._gameMode = null;
    this._filterAlbumMode = ALLMODE;
    this._groupId = null;
    this._round = 1;
    this._scoreMax = 0;
    this._multiplicatorScore = 0;
    this._score = 0;
    this._life = 0;
    this._time = 0;
    this._endSequenceFunction = () => {};
    this._readyToStart = false;
    makeAutoObservable(this);
  }

  // GETTERS
  get answerAlbumList() {
    return this._answerAlbumList;
  }
  get userAlbumList() {
    return this._userAlbumList;
  }
  get currentAlbum() {
    return this._currentAlbum;
  }
  get gameMode() {
    return this._gameMode;
  }
  get filterAlbumMode() {
    return this._filterAlbumMode;
  }
  get groupId() {
    return this._groupId;
  }
  get round() {
    return this._round;
  }
  get scoreMax() {
    return this._scoreMax;
  }
  get multiplicatorScore() {
    return this._multiplicatorScore;
  }
  get score() {
    return this._score;
  }
  get lifeMax() {
    return this._lifeMax;
  }
  get life() {
    return this._life;
  }
  get time() {
    return this._time;
  }
  get endSequenceFunction() {
    return this._endSequenceFunction;
  }
  get readyToStart() {
    return this._readyToStart;
  }

  // SETTERS
  set answerAlbumList(answerAlbumList) {
    this._answerAlbumList = answerAlbumList;
  }
  set userAlbumList(userAlbumList) {
    this._userAlbumList = userAlbumList;
  }
  set currentAlbum(currentAlbum) {
    this._currentAlbum = currentAlbum;
  }
  set gameMode(gameMode) {
    this._gameMode = gameMode;
  }
  set filterAlbumMode(filterAlbumMode) {
    this._filterAlbumMode = filterAlbumMode;
  }
  set groupId(groupId) {
    this._groupId = groupId;
  }
  set round(round) {
    this._round = round;
  }
  set scoreMax(scoreMax) {
    this._scoreMax = scoreMax;
  }
  set multiplicatorScore(multiplicatorScore) {
    this._multiplicatorScore = multiplicatorScore;
  }
  set score(score) {
    this._score = score;
  }
  set lifeMax(lifeMax) {
    this._lifeMax = lifeMax;
  }
  set life(life) {
    this._life = life;
  }
  set time(time) {
    this._time = time;
  }
  set endSequenceFunction(endSequenceFunction) {
    this._endSequenceFunction = endSequenceFunction;
  }
  set readyToStart(readyToStart) {
    this._readyToStart = readyToStart;
  }

  //METHODS
  addScore(scoreToAdd) {
    if (this._score+scoreToAdd<=0) {
      this._score = 0;
    } else {
      this._score+=scoreToAdd;
    }
  }



  startGame({ answerAlbumList, multiplicatorScore, endSequenceFunction, gameMode, filterAlbumMode, groupId}) {
    this._answerAlbumList = answerAlbumList;
    this._userAlbumList = [
      {
        album: answerAlbumList[0],
        correction: true,
      },
    ];
    this._currentAlbum = answerAlbumList[1];
    this.round = 1;
    this._multiplicatorScore = multiplicatorScore;
    this._scoreMax = (this._answerAlbumList.length-1) * this._multiplicatorScore;
    this._score = 0;
    this._gameMode = gameMode;
    this._filterAlbumMode = filterAlbumMode;
    this._groupId = groupId;
    this._endSequenceFunction = endSequenceFunction;
    this._readyToStart = true;
  }

  validateAlbum({index, validateFunction = () => {}}) {
    // Si la partie n'est pas intilisalisé on ne lance pas
    if (!this._readyToStart) {
      console.error("answerAlbumList n'est pas encore défini");
      return null;
    }
    if (this.round>=this._answerAlbumList.length) {

    }
    // on augmente le round
    this._round += 1; 
    

    // on vérifie la condition de victoire
    let isCorrect =
      (!this._userAlbumList[index - 1]?.album ||
        this._userAlbumList[index - 1].album.dateAlbum <=
          this._currentAlbum.dateAlbum) &&
      (!this._userAlbumList[index]?.album ||
        this._userAlbumList[index].album.dateAlbum >=
          this._currentAlbum.dateAlbum);

    // Si la réponse est fausse
    if (isCorrect) {
      this._score += this.multiplicatorScore;
    }

    // on place le new current et l'ancien dans la liste
    this._userAlbumList.push({
      album: this.currentAlbum,
      correction: isCorrect,
    });
    this.currentAlbum = this._answerAlbumList[this._round];
    // on trie la liste
    this._userAlbumList.sort(
      (album_1, album_2) => album_1.album.dateAlbum - album_2.album.dateAlbum
    );
    
    // on vérifie enfin si on a pas fini la partie
    if (this.round===this._answerAlbumList.length) {
      this.endSequence({reason:"game-end"});
    }
    validateFunction();
  }

  endSequence({reason = null}={}) {
    // on active tout les éléments visuels via la fonction partagé
    this.endSequenceFunction({reason : reason});
    // on ajoute le score au profil

    //on reset les variables
  }









  // INFINITE //


  startInfiniteGame({albumList, gameMode, nbHeart, multiplicatorScore, endSequenceFunction}) {
    this._answerAlbumList = albumList;
    this._userAlbumList = [
      {
        album: albumList[0],
        correction: true,
      },
    ];
    this._currentAlbum = albumList[1];
    this._round = 1;
    this._multiplicatorScore = multiplicatorScore;
    this._score = 0;
    this._life = nbHeart;
    this._lifeMax = nbHeart;
    this._gameMode = gameMode;
    this._endSequenceFunction = endSequenceFunction;
    this._readyToStart = true;
    // NON ESSENTIAL
    this._filterAlbumMode = null;
    this._groupId = null;
    this.scoreMax = null;
  }

  validateAlbumInfiniteGame({index, validateFunction = () => {}}) {
    // Si la partie n'est pas intilisalisé on ne lance pas
    if (!this._readyToStart) {
      console.error("answerAlbumList n'est pas encore défini");
      return null;
    }

    

    // on vérifie la condition de victoire
    let isCorrect =
      (!this._userAlbumList[index - 1]?.album ||
        this._userAlbumList[index - 1].album.dateAlbum <=
          this._currentAlbum.dateAlbum) &&
      (!this._userAlbumList[index]?.album ||
        this._userAlbumList[index].album.dateAlbum >=
          this._currentAlbum.dateAlbum);

    // Si la réponse est fausse
    if (isCorrect) {
      this._score += this.multiplicatorScore;
    } else {
      this._life-= 1;
    }

    // on place le new current et l'ancien dans la liste
    this._userAlbumList.push({
      album: this.currentAlbum,
      correction: isCorrect,
    });
    this.currentAlbum = this._answerAlbumList[this._round+1];
    // on trie la liste
    this._userAlbumList.sort(
      (album_1, album_2) => album_1.album.dateAlbum - album_2.album.dateAlbum
    );
    
    // on vérifie enfin si on a pas fini la partie
    if (this._life<=0) {
      this.endSequenceInfiniteGame({reason:"no-life"});
    } else {
      // on augmente le round
      this._round += 1;
    }
    validateFunction();
  }

  endSequenceInfiniteGame({reason = null}={}) {
    // on active tout les éléments visuels via la fonction partagé
    console.log("fini");
    this.endSequenceFunction({reason : reason});
    // on ajoute le score au profil

    //on reset les variables
  }


}
